export default __webpack_public_path__ + "static/media/agenda-icon-purple-min.02a4458c.png";